const socketEvents = {
  ACTIVE_CONNECTIONS_LIST: 'active_connections_list',
  CHUNK: 'chunk',
  CLIENT_NOT_FOUND: 'client_not_found',
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  ERROR: 'error',
  HEARTBEAT: 'heartbeat',
  HEARTBEAT_RESPONSE: 'heartbeat_response',
  HOST_NOT_FOUND: 'host_not_found',
  LOCK_SUCCESS: 'lock_success',
  MESSAGE: 'message',
  REGISTER: 'register',
  REGISTRATION_SUCCESS: 'registration_success',
  SUBSCRIBE: 'subscribe',
  SUBSCRIBED: 'subscribed',
  UNLOCK_SUCCESS: 'unlock_success',
  WAITING_FOR_ONCALL_TO_ANSWER: 'waiting_for_oncall_to_answer',
  WAITING_FOR_USER_TO_ANSWER: 'waiting_for_user_to_answer',

  BrowserRunUpdate: 'BrowserRunUpdate',
  WorkflowLogUpdate: 'WorkflowLogUpdate',
  WorkflowRunNameUpdate: 'WorkflowRunNameUpdate',
};

export default socketEvents;
